import script from "./UnitsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitsPage.vue?vue&type=script&setup=true&lang=js"

import "./UnitsPage.vue?vue&type=style&index=0&id=3fe2680c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe2680c"]])

export default __exports__